import { useEffect } from "react";

import { useRouter } from "next/router";
import ReactPaginate from "react-paginate";
import client from "tina/__generated__/databaseClient";
import { useTina } from "tinacms/dist/react";

import { ROUTES } from "@/helpers/routes";
import Layout from "@/shared/components/layout";
import PageSeo from "@/shared/components/PageSeo";
import PostHeroSection from "@/shared/features/posts/PostHeroSection";
import { PostPageNameEnum } from "@/types/posts";

export default function News(props: any) {
    const router = useRouter();
    const mainPage: any = router.query.page;
    const maindata = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    const newsList = maindata.data.newsConnection.edges;

    const itemsPerPage = 4;
    const pageCount = Math.ceil(newsList.length / itemsPerPage);

    const page: any = !isNaN(mainPage as any) && mainPage !== undefined && mainPage <= pageCount ? +mainPage as any : 1;
    const itemOffset = 4 * (page - 1);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = newsList.slice(itemOffset, endOffset);

    useEffect(() => {
        if (router.isReady && mainPage !== undefined && (isNaN(mainPage as any) || mainPage > pageCount)) {
            router.push("/news");
        }
    }, [router, mainPage, pageCount]);

    const handlePageClick = (selectedItem: any) => {
        let path = "/news";
        if (selectedItem.selected !== 0) {
            path += `?page=${selectedItem.selected + 1}`;
        }
        router.push(path);
    };

    return (
        <div>
            <PageSeo title="News | The Gender Index" pathname={ROUTES.news} />
            <Layout>
                {
                    ((!isNaN(mainPage as any) || mainPage === undefined || mainPage <= pageCount))
                    && <div className="multipleLayoutWrap">
                        <div className='singleLayout resourcePage'>
                            <h3>
                                News and media
                            </h3>
                            {
                                currentItems.map((post: any) => (
                                    <PostHeroSection
                                        data={post.node}
                                        key={post.node.id}
                                        pageName={PostPageNameEnum.news}
                                        page={page === 1 ? undefined : page} />
                                ))
                            }
                            <div className='pagination'>
                                <ReactPaginate
                                    nextLabel=">"
                                    nextClassName="next"
                                    onPageChange={handlePageClick}
                                    pageCount={pageCount}
                                    previousLabel="<"
                                    previousClassName="prev"
                                    renderOnZeroPageCount={null}
                                    initialPage={page - 1}
                                    disabledLinkClassName="disableBtn"
                                />
                            </div>
                        </div>
                    </div>
                }
            </Layout>
        </div>
    );
}
export const getStaticProps = async () => {
    const data = await client.queries.newsConnection({
        sort: "date_published",
        last: 10000,
    });
    return {
        props: data,
    };
};

